import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const maritimeTransport = 'M';

class Checker extends Component {
  constructor(props) {
    super(props);
    this.handleCheckClick = this.handleCheckClick.bind(this);
  }

  handleCheckClick() {
    this.props.toggleMarkInSpecialOrders(this.props.index);
  }

  render() {
    if (this.props.transport === maritimeTransport) {
      return null;
    }

    return (
      <Checkbox
        disabled={this.props.disabled}
        checked={this.props.checked}
        onClick={this.handleCheckClick}
      />
    );
  }
}

Checker.propTypes = {
  'index': PropTypes.number.isRequired,
  'checked': PropTypes.bool,
};

Checker.defaultProps = {
  'checked': false,
};

const {toggleMarkInSpecialOrders} = Actions;

export default connect(null, {toggleMarkInSpecialOrders})(Checker);
